import {Component, Input, OnInit} from '@angular/core';
import {
    BaseModalComponent,
    DonationProgram,
    DonationProgramPayout,
    DonationProgramPayoutService,
    formatCurrencyToNumeric,
    LoadingService
} from 'brewbill-lib';
import {ModalController} from '@ionic/angular';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'bb-edit-donation-program-payout',
    templateUrl: './edit-donation-program-payout.component.html',
    styleUrls: ['./edit-donation-program-payout.component.scss'],
})
export class EditDonationProgramPayoutComponent extends BaseModalComponent implements OnInit {
    @Input() donationProgram: DonationProgram;
    @Input() outstanding: number;

    formGroup: FormGroup;

    constructor(
        modalController: ModalController,
        private formBuilder: FormBuilder,
        private donationProgramPayoutService: DonationProgramPayoutService,
        private loadingService: LoadingService
    ) {
        super(modalController);
    }

    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            parentId: this.donationProgram.id,
            amount: ['', Validators.required],
            method: '',
            other: ''
        });

        this.formGroup.get('method').valueChanges.subscribe(v => {
            if (!!v) {
                this.formGroup.get('other').setValidators([]);
            } else {
                this.formGroup.get('other').setValidators([Validators.required]);
            }
            this.formGroup.get('other').updateValueAndValidity();
        });
    }

    maxPayout() {
        this.formGroup.get('amount').setValue(this.outstanding);
        this.formGroup.get('amount').updateValueAndValidity();
    }

    onSubmit() {
        this.loadingService.present();
        const payout = new DonationProgramPayout(this.formGroup.value);
        payout.amount = formatCurrencyToNumeric(payout.amount);
        if (!payout.method) {
            payout.method = this.formGroup.get('other').value;
        }
        this.donationProgramPayoutService.create(payout).subscribe(p => {
            this.loadingService.dismiss();
            this.close(p);
        });
    }
}
